export const executionStatusGroup = [
  {
    label: '全部',
    value: '',
    en: 'allCount',
    count: 0,
  },
  {
    label: '待收货',
    value: '1',
    en: 'waitReceiveCount',
    count: 0,
  },
  {
    label: '部分收货',
    value: '2',
    en: 'partReceiveCount',
    count: 0,
  },
  {
    label: '已收货',
    value: '3',
    en: 'allReceiveCount',
    count: 0,
  },
];

export const logisticsStatusOptions = [
  {
    label: '未签收',
    value: 0,
  },
  {
    label: '部分签收',
    value: 1,
  },
  {
    label: '已签收',
    value: 2,
  },
];

